export const FUNDRAISER_LABELS = {
  en: {
    default: `Let's get you started`,
    ngo: 'Raising funds for NGO',
    someoneElseWithName: `{{name}}'s {{cause}} Fundraiser`,
    someoneElseWithRelation: `{{name}} {{relation}}'s Fundraiser`,
    self: `{{name}}'s Fundraiser`,
    selfWithCause: `{{name}}'s {{cause}} Fundraiser`,
    relations: {
      Mother: 'Mother',
      Father: 'Father',
      Son: 'Son',
      Daughter: 'Daughter',
      Friend: 'Friend',
      Aunt: 'Aunt',
      Brother: 'Brother',
      Cousin: 'Cousin',
      "Friend's Family": "Friend's Family",
      Granddaughter: 'Granddaughter',
      Grandfather: 'Grandfather',
      Grandmother: 'Grandmother',
      Grandson: 'Grandson',
      Husband: 'Husband',
      "Legal ward": 'Legal ward',
      Nephew: 'Nephew',
      Niece: 'Niece',
      Relative: 'Relative',
      Sister: 'Sister',
      Twins: 'Twins',
      Uncle: 'Uncle',
      Wife: 'Wife',
      Pet: 'Pet',
      Other: '',
    },
  },
  hi: {
    default: `चलिए शुरू करते हैं`,
    ngo: 'NGO के लिए फंड इकट्ठा कर रहे हैं',
    someoneElseWithName: `{{name}} का {{cause}} फंडरेज़र`,
    someoneElseWithRelation: `{{name}} के {{relation}} का फंडरेज़र`,
    self: `{{name}} का फंडरेज़र`,
    selfWithCause: `{{name}} का {{cause}} फंडरेज़र`,
    relations: {
      Mother: 'माँ',
      Father: 'पिता',
      Son: 'बेटा',
      Daughter: 'बेटी',
      Friend: 'मित्र',

      Aunt: 'चाची / मौसी',
      Brother: 'भाई',
      Cousin: 'चचेरा भाई / बहन',
      "Friend's Family": 'मित्र का परिवार',
      Granddaughter: 'पोती',
      Grandfather: 'दादा / नाना',
      Grandmother: 'दादी / नानी',
      Grandson: 'पोता',
      Husband: 'पति',
      "Legal ward": 'कानूनी संरक्षकता',
      Nephew: 'भतीजा',
      Niece: 'भतीजी',
      Relative: 'रिश्तेदार',
      Sister: 'बहन',
      Twins: 'जुड़वाँ',
      Uncle: 'चाचा / मामा',
      Wife: 'पत्नी',
      Pet: 'पालतू जानवर',
      Other: '',
    },
  },
  ta: {
    default: `வாங்க, ஆரம்பிக்கலாம்`,
    ngo: 'என்ஜிஓவிற்காக நிதி திரட்டி வருகிறேன்',
    someoneElseWithName: `{{name}} {{cause}} இன் நிதி திரட்டல்`,
    someoneElseWithRelation: `{{name}} {{relation}} இன் நிதி திரட்டல்`,
    self: `{{name}} இன் நிதி திரட்டல்`, 
    selfWithCause: `{{name}} இன் {{cause}} நிதி திரட்டல்`,
    relations: {
      Mother: 'அம்மா',
      Father: 'அப்பா',
      Son: 'மகன்',
      Daughter: 'மகள்',
      Friend: 'நண்பர்',
      Aunt: 'அத்தை / மாமி',
      Brother: 'சகோதரன்',
      Cousin: 'மருமகன் / மருமகள்',
      "Friend's Family": 'நண்பரின் குடும்பம்',
      Granddaughter: 'பேரப்பெண்',
      Grandfather: 'தாத்தா',
      Grandmother: 'பாட்டி',
      Grandson: 'பேரன்',
      Husband: 'கணவன்',
      "Legal ward": 'சட்ட வார்டு',
      Nephew: 'அண்ணன் மகன்',
      Niece: 'அண்ணன் மகள்',
      Relative: 'உறவினர்',
      Sister: 'சகோதரி',
      Twins: 'இரட்டையர்கள்',
      Uncle: 'மாமா / சித்தப்பா',
      Wife: 'மனைவி',
      Pet: 'செல்லப்பிராணி',
      Other: '',
    },
  },
  te: {
    default: `ముందుకు సాగదాం`,
    ngo: 'ఎన్జీవో కోసం నిధులను సమీకరిస్తున్నారు',
    someoneElseWithName: `{{name}} యొక్క {{cause}} ఫండ్రైజర్`,
    someoneElseWithRelation: `{{name}} {{relation}} యొక్క ఫండ్రైజర్`,
    self: `{{name}} యొక్క ఫండ్రైజర్`,
    selfWithCause: `{{name}} యొక్క {{cause}} ఫండ్రైజర్`,
    relations: {
      Mother: 'తల్లి',
      Father: 'తండ్రి',
      Son: 'కొడుకు',
      Daughter: 'కుమార్తె',
      Friend: 'స్నేహితుడు',
      Aunt: 'అత్త / పిన్ని',
      Brother: 'అన్న / తమ్ముడు',
      Cousin: 'బంధువు',
      "Friend's Family": 'స్నేహితుని కుటుంబం',
      Granddaughter: 'మనవరాలు',
      Grandfather: 'తాతయ్య',
      Grandmother: 'నాయనమ్మ / అమ్మమ్మ',
      Grandson: 'మనవడు',
      Husband: 'భర్త',
      "Legal ward": 'చట్టపరమైన సంరక్షితుడు',
      Nephew: 'మేనల్లుడు',
      Niece: 'మేనకోడలు',
      Relative: 'సంబంధిత వ్యక్తి',
      Sister: 'చెల్లెమ్మ',
      Twins: 'జంటలు',
      Uncle: 'మామ / బాబాయ్',
      Wife: 'భార్య',
      Pet: 'పెంపుడు జంతువు',
      Other: '',
    },
  },
};
